import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Mail from '@wix/da-ds/pkg/Icons/24x24/Mail';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Button from '../../../Button';
import VerificationEmailInput from '../../../VerificationEmailInput';
import { Props as ParentProps } from './VerificationReminder';
import verificationReminderStyles from './VerificationReminder.scss';

type Props = Omit<ParentProps, 'isSendingDone'>;

export const VerificationNeeded: React.FC<React.PropsWithChildren<Props>> = ({
  email,
  isUnverified,
  resendEmail,
  isEmailChangeInProgress,
  isResendInProgress,
  hideChangeEmail,
}) => {
  const { t } = useTranslation();
  const isChangeInProgress = isEmailChangeInProgress || isResendInProgress;

  return (
    <div
      className={classnames(
        verificationReminderStyles['root'],
        isUnverified && verificationReminderStyles['doormat']
      )}
    >
      <div className={verificationReminderStyles['header']}>
        <Mail className={verificationReminderStyles['message-icon']} size={IconSize.MEDIUM} />
        {t('siteHeader.verification.verifyEmail')}
      </div>
      <div className={verificationReminderStyles['text']}>
        <p>{t('siteHeader.verification.checkEmail')}</p>
      </div>
      <Button
        isFakeButton
        view="b3"
        height="medium"
        onClick={resendEmail}
        className={verificationReminderStyles['resend-button']}
        disabled={isChangeInProgress}
        forceHoverStateWhenDisabledBecauseReasons={isResendInProgress}
        fullWidth={false}
      >
        {t(
          isResendInProgress
            ? 'siteHeader.verification.resending'
            : 'siteHeader.verification.resend'
        )}
      </Button>
      <div className={verificationReminderStyles['text-small']}>
        {isUnverified ? (
          <PlainButtonOrLink
            href="https://www.deviantartsupport.com/en/article/what-if-im-having-trouble-verifying-my-account"
            target="_blank"
          >
            {t('siteHeader.verification.notMe', { email })}
          </PlainButtonOrLink>
        ) : (
          t('siteHeader.verification.notMe', { email })
        )}
      </div>
      {!(hideChangeEmail || isUnverified) && (
        <VerificationEmailInput
          className={verificationReminderStyles['email-input']}
          noBottomSpacing={true}
        />
      )}
    </div>
  );
};
VerificationNeeded.displayName = 'VerificationNeeded';

export default VerificationNeeded;
